import script from "./VideoCoursewareCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./VideoCoursewareCard.vue?vue&type=script&lang=ts&setup=true"

import "./VideoCoursewareCard.vue?vue&type=style&index=0&id=f62fd11a&scoped=true&lang=css"
import "./VideoCoursewareCard.vue?vue&type=style&index=1&id=f62fd11a&lang=less&scoped=true"
script.__scopeId = "data-v-f62fd11a"

export default script